import { React, useState, useEffect, useRef } from "react";
import Header from "../Header";
import { FetchMentorDetails } from "../../api/aws-api";
import { ConstructorEventGet } from "../../Event/event";
import { ClassicSpinner } from "react-spinners-kit";
import { useLocation } from 'react-router-dom';
import { FetchBatchData, TransferStudentsToMentor } from "../../api/aws-api";
// NOTE: TransferStudentsToMentor does not exist yet in aws-api.js / backend.
// Add it once the corresponding Lambda + API Gateway route are created.
// Expected shape of what this page POSTs, per source batch:
//   {
//     "sourceBatchId": "<BatchId of the batch the students are being pulled from>",
//     "sourceMentorId": "<mentorId that currently owns them>",
//     "targetMentorId": "<mentorId selected on this page>",
//     "students": [ { key, name, email, mobile, ... }, ... ]  // only the checked ones
//   }
// What the backend does with that (move into an existing batch of the target
// mentor vs. create a new batch) still needs to be decided — see chat.
import { ConstructorEventPost } from "../../Event/event";
import Swal from 'sweetalert2'


const TransferBatchToMentor = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false)
    const [mentorList, setMentorList] = useState([])
    const [selectedMentorName, setSelectedMentorName] = useState("")
    const [selectedMentorId, setSelectedMentorId] = useState("")
    const [defaultMentorName, setDefaultMentorName] = useState("")
    const [defaultMentorId, setDefaultMentorId] = useState("")
    const [batchList, setBatchList] = useState([])
    // selectedStudents: array of { student, BatchId } pairs — tracks which
    // batch each selected student came from, since one transfer can pull
    // students out of multiple batches of the same mentor at once.
    const [selectedStudents, setSelectedStudents] = useState([])
    const checkboxesRef = useRef([]);

    useEffect(() => {
        fetchMentorDetails()
        getBatchDetailsOfTheMentor()
    }, [])

    const fetchMentorDetails = async () => {
        setLoading(true)
        const responsedata = await ConstructorEventGet(FetchMentorDetails)

        const mentorid = location.state || {};

        const mentorList = responsedata.filter((ele) => {
            return ele.user_id !== mentorid.mentorId
        })

        const defaultMentor = responsedata.filter((ele) => {
            return ele.user_id === mentorid.mentorId
        })

        setDefaultMentorName(defaultMentor[0].user_name)
        setDefaultMentorId(defaultMentor[0].user_id)

        setMentorList(mentorList)
        setLoading(false)
    }

    const getBatchDetailsOfTheMentor = async () => {
        const mentorid = location.state || {};
        const responsedata = await ConstructorEventGet(FetchBatchData, { "mentorId": mentorid.mentorId })
        setBatchList(responsedata)
    }

    const selectMentor = (ele) => {
        setSelectedMentorName(ele.user_name)
        setSelectedMentorId(ele.user_id)
    }

    const isStudentSelected = (studentKey, batchId) => {
        return selectedStudents.some(
            (entry) => entry.student.key === studentKey && entry.BatchId === batchId
        );
    }

    const toggleStudent = (student, batchId, event) => {
        const { checked } = event.target;

        if (selectedMentorId === "") {
            Swal.fire({
                icon: "warning",
                title: "Please select a target mentor before selecting students",
            });
            return;
        }

        if (checked) {
            setSelectedStudents((prev) => [...prev, { student, BatchId: batchId }]);
        } else {
            setSelectedStudents((prev) =>
                prev.filter(
                    (entry) => !(entry.student.key === student.key && entry.BatchId === batchId)
                )
            );
        }
    }

    const transferStudents = async () => {
        if (selectedStudents.length === 0) {
            Swal.fire({ icon: "warning", title: "Select at least one student to transfer" });
            return;
        }
        if (selectedMentorId === "") {
            Swal.fire({ icon: "warning", title: "Select a target mentor" });
            return;
        }

        setLoading(true)

        // Group selected students by the batch they're being pulled from,
        // since each source batch needs its own transfer call.
        const groupedByBatch = selectedStudents.reduce((acc, entry) => {
            if (!acc[entry.BatchId]) acc[entry.BatchId] = [];
            acc[entry.BatchId].push(entry.student);
            return acc;
        }, {});

        try {
            for (const [batchId, students] of Object.entries(groupedByBatch)) {
                const response = await ConstructorEventPost(TransferStudentsToMentor, {
                    "sourceBatchId": batchId,
                    "sourceMentorId": defaultMentorId,
                    "targetMentorId": selectedMentorId,
                    "targetMentorName": selectedMentorName,
                    "students": students,
                })

                if (response.status !== "success") {
                    throw new Error(response.message || "Transfer failed");
                }
            }

            setSelectedMentorId("")
            setSelectedMentorName("")
            setSelectedStudents([])
            setLoading(false)

            Swal.fire({ icon: "success", title: "Students Transferred Successfully" });
            getBatchDetailsOfTheMentor()
        } catch (e) {
            setLoading(false)
            Swal.fire({ icon: "error", title: `Error While Transferring Students`, text: e.message })
        }
    }

    return (
        <>
            <Header />
            {loading ?
                <div className="spinner" >
                    <div className="spinner-wrapper">
                        <ClassicSpinner size={50} color="black" loading={loading} />
                    </div></div> :
                <div className="nav-tab-wrapper tabs  section-padding">
                    <div className="container">
                        <div className="mini-title">Transfer Students To Mentor</div>
                        <div className=" grid grid-cols-12 gap-[30px]">

                            <div className="xl:col-span-6 lg:col-span-6 col-span-12 mt-8">
                                <div className="bg-white shadow-box7 p-8 rounded-md">
                                    <div className="text-center">
                                        <b>Target Mentor</b>
                                    </div>
                                    <div>
                                        {mentorList.map((ele, index) => (
                                            <p className="shadow-sm p-4 bg-body-tertiary rounded" style={{ cursor: "pointer" }} key={index}>
                                                <input type='radio'
                                                    checked={selectedMentorName === ele.user_name}
                                                    name={"targetMentor"}
                                                    id={index} value={ele.user_id}
                                                    ref={(el) => (checkboxesRef.current[index] = el)}
                                                    onChange={() => selectMentor(ele)}
                                                />
                                                {" "}{ele.user_name}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="xl:col-span-6 lg:col-span-6 col-span-12 ">
                                <div className="bg-white shadow-box7 p-8 rounded-md mt-8">
                                    <div className="text-center">
                                        <b>{`${defaultMentorName} Batches — Select Students`}</b>
                                    </div>
                                    <div className="hover:shadow-box hover:bg-red">
                                        {batchList.map((batchEle, batchIndex) => (
                                            <div className="shadow-sm p-4 bg-body-tertiary rounded" key={batchIndex}>
                                                <p><b>Batch:</b> {batchEle.BatchName}</p>
                                                <p><b>Start Date:</b> {batchEle.StartDate}</p>
                                                <p><b>End Date:</b> {batchEle.EndDate}</p>
                                                <p><b>BatchProgress:</b> {batchEle.batchProgress}</p>
                                                <p><b>Students:</b></p>
                                                <div style={{ paddingLeft: "16px" }}>
                                                    {batchEle.StudentsEndrolled.map((student, studentIndex) => (
                                                        <label
                                                            key={studentIndex}
                                                            style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={isStudentSelected(student.key, batchEle.BatchId)}
                                                                onChange={(event) => toggleStudent(student, batchEle.BatchId, event)}
                                                            />
                                                            {student.name} {student.email ? `(${student.email})` : ""}
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="text-center mt-6">
                            <button className="btn btn-primary" type="button" onClick={transferStudents}>
                                Transfer Selected Students To Mentor
                            </button>
                        </div>

                    </div>
                </div>
            }
        </>
    )
}

export default TransferBatchToMentor;